import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar/Navbar";
import Home from "./pages/Home/Home";
import About from "./pages/About/About";
import Portfolio from "./pages/Portfolio/Portfolio";
import Career from "./pages/Career/Career";
import TechnicalTraining from "./pages/Services/TechnicalTraining/TechnicalTraining";
import Mern from "./pages/Services/TechnicalTraining/Courses/Mern";
import WebDevelopment from "./pages/Services/WebDevelopment/WebDevelopment";
import Footer from "./components/Footer/Footer";
import ITStaffing from "./pages/Services/ITStaffing/ITStaffing";
import Contact from "./components/contact/Contact";
import MobileDevelopment from "./pages/Services/MobileDevelopment/MobileDevelopment";
import EducationalSupport from "./pages/Services/EducationalSupport/EducationalSupport";
import SwDevOutsourcing from "./pages/Services/SwDevOutsourcing/SwDevOutsourcing";
import JavaFull from "./pages/Services/TechnicalTraining/Courses/JavaFull";
import AIML from "./pages/Services/TechnicalTraining/Courses/AIML";
import DataScience from "./pages/Services/TechnicalTraining/Courses/DataScience";
import Cloud from "./pages/Services/TechnicalTraining/Courses/Cloud";
import DevOps from "./pages/Services/TechnicalTraining/Courses/DevOps";
import Register from "./pages/registerLogin/Register";
import ScrollToTop from "./ScrollToTopOnPageChange";
import PrivacyPolicy from "./pages/Privacy/PrivacyPolicy";
import TermsCondition from "./pages/Privacy/TermsCondition";
import { AuthProvider } from "./store/auth.jsx";
import { useState } from "react";
import SignupPopup from "./components/Signup/SignupPopup.jsx";
import Logout from "./pages/Logout.jsx";
import { Error } from "./pages/Error.jsx";
import Footer2 from "./components/Footer/Footer2.jsx";
import ManualAlertpage from "./components/Alert/ManualAlertpage.jsx";
import Misrow from "./components/Products/MISROW/Misrow.jsx";
import TestSeries from "./components/Products/TEST_SERIES/TestSeries.jsx";

function App() {

  const [showSignupPopup, setShowSignupPopup] = useState(false);


  const toggleSignupPopup = () => {
    setShowSignupPopup(!showSignupPopup);
  };


  return (
    <>
      <AuthProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Navbar />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/portfolio" element={<Portfolio />} />
            <Route path="/career" element={<Career />} />
            <Route path="/technicalTraining" element={<TechnicalTraining />} />
            <Route path="/mern" element={<Mern />} />
            <Route path="/javafull" element={<JavaFull />} />
            <Route path="/aiml" element={<AIML />} />
            <Route path="/datascience" element={<DataScience />} />
            <Route path="/cloud" element={<Cloud />} />
            <Route path="/devops" element={<DevOps />} />
            <Route path="/SwDevOutsourcing" element={<SwDevOutsourcing />} />
            <Route path="/webd" element={<WebDevelopment />} />
            <Route path="/mobiled" element={<MobileDevelopment />} />
            <Route path="/itstaffing" element={<ITStaffing />} />
            <Route path="/EducationSupport" element={<EducationalSupport />} />
            <Route path="/register" element={<Register />} />
            <Route path="/privacyPolicy" element={<PrivacyPolicy />} />
            <Route path="/terms" element={<TermsCondition />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/signup" element={<SignupPopup handleClose={toggleSignupPopup} />} />
            <Route path="/logout" element={<Logout />} />

            <Route path='/products/misrow' element={<Misrow />} />
            <Route path="/product/test-series" element={<TestSeries />} />
            
            <Route path="*" element={<Error />} />
          </Routes>
          {/* <Footer /> */}
          <Footer2 />
        </BrowserRouter>
      </AuthProvider>
    </>
  );
}

export default App;
